<template lang="pug">
    v-card(shaped class="ma-1")
        v-card-actions
            v-btn(icon @click="removeTrip")
              v-icon mdi-close
            span(class="swatch" :style="swatchStyle")
            v-col(cols=8)
                div.text-h6(v-show="!editing" @click="editing = !editing;") {{ trip.title }}
                v-text-field(dense v-show="editing" v-model="trip.title" @blur="editing = !editing" @click="startEditing")
            v-spacer
            v-btn(icon @click="show =! show")
                v-icon {{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        v-expand-transition
          v-row(v-show="show" class="pa-4")
            v-col(cols=12)
              v-row(align="baseline")
                  v-col(cols=12) 
                      AddressFinder(:model="trip.fromAddress" :clear="true" label="Starting from" :myAddress="myAddress")
              v-row(align="baseline" justify="center")
                  v-col(class="spacer" cols=1)
                      v-btn(fab x-small @click="addVia(0)")
                          v-icon mdi-plus
              div(v-for="(v, index) in trip.viaAddresses" :key="v.id ? v.id : v.osm_id")
                  v-row(align="baseline")
                      v-col(cols=11) 
                          AddressFinder(:model="v" :clear="true" label="Then going to" )
                      v-col(cols=1 justify-self="left")
                          v-btn(tile icon x-small @click="removeVia(index)")
                              v-icon mdi-close
                  v-row(align="center" justify="center")
                      v-col(class="right spacer" cols=1)
                          v-btn(fab x-small @click="addVia(index + 1)")
                              v-icon mdi-plus
              v-row(align="baseline")
                  v-col(cols=12) 
                      AddressFinder(:model="trip.toAddress" :clear="true" label="Ending at")
            
</template>

<script>
import AddressFinder from "./AddressFinder.vue";
import TripCardSupport from "../mixins/TripCardSupport.js";
export default {
  props: ["trip", "expanded", "editTitle", "colour", "myAddress"],
  mixins:[TripCardSupport],
  data() {
    return {
      editing: this.editTitle,
      show: this.expanded,
      panel: [],
      swatchStyle: {
        background: this.colour
      }
    };
  },
  components: {
    AddressFinder
  },
  methods: {
        startEditing() {
      if (this.trip.title == "Give this trip a name") {
        this.trip.title = "";
      }
    },
    removeTrip() {
      this.$emit("remove", this.trip);
    },
    addVia(index) {
      this.trip.viaAddresses.splice(index, 0, {
        id: this.trip.viaAddresses.length + 1
      });
    },
    removeVia(index) {
      this.trip.viaAddresses.splice(index, 1);
    },
    updateTripData() {

      if (
        this.trip.fromAddress.Address != null &&
        this.trip.toAddress.Address != null
      ) {
        this.$emit("tripUpdated")
      }
    }
  }
};
</script>
<style scoped>
.right {
  text-align: right;
}
.detail {
  color: #666666;
  font-size: 0.8em;
}
.per {
  font-style: italic;
  text-align: center;
  width: 100%;
  display: block;
}
.spacer {
  height: 24px;
}
.spacer * {
  position: relative;
  top: 50%;
}
.swatch {
  width: 12px;
  height: 12px;
  content: " ";
  display: block;
  background: blue;
}
</style>